import MultiSelectFilter from '@/components/MultiSelectFilter'
import type { MultiSelectOption } from '@/components/MultiSelectFilter'
import type { VendorTableFilters } from '@/pages/vendorDetailsFilters'

interface VendorDetailsFilterBarProps {
  filters: VendorTableFilters
  options: {
    display_name: MultiSelectOption[]
    active: MultiSelectOption[]
    marketplace: MultiSelectOption[]
    payment_method: MultiSelectOption[]
    liability_timing: MultiSelectOption[]
    term_ref: MultiSelectOption[]
  }
  onChange: <K extends keyof VendorTableFilters>(key: K, value: VendorTableFilters[K]) => void
}

export default function VendorDetailsFilterBar({
  filters,
  options,
  onChange,
}: VendorDetailsFilterBarProps) {
  return (
    <div className="flex flex-col gap-4">
      <MultiSelectFilter
        id="vendor-filter-name"
        label="Vendor name"
        options={options.display_name}
        selected={filters.display_name}
        onChange={(value) => onChange('display_name', value)}
        searchable
      />
      <MultiSelectFilter
        id="vendor-filter-status"
        label="Status"
        options={options.active}
        selected={filters.active}
        onChange={(value) => onChange('active', value)}
      />
      <MultiSelectFilter
        id="vendor-filter-marketplace"
        label="Marketplace"
        options={options.marketplace}
        selected={filters.marketplace}
        onChange={(value) => onChange('marketplace', value)}
      />
      <MultiSelectFilter
        id="vendor-filter-payment-method"
        label="Payment method"
        options={options.payment_method}
        selected={filters.payment_method}
        onChange={(value) => onChange('payment_method', value)}
      />
      <MultiSelectFilter
        id="vendor-filter-liability-timing"
        label="Liability timing"
        options={options.liability_timing}
        selected={filters.liability_timing}
        onChange={(value) => onChange('liability_timing', value)}
      />
      <MultiSelectFilter
        id="vendor-filter-payment-terms"
        label="Payment terms"
        options={options.term_ref}
        selected={filters.term_ref}
        onChange={(value) => onChange('term_ref', value)}
      />
    </div>
  )
}
